import { PropsWithChildren } from 'react';

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';

import { DropDownMenuDesktop } from './DropDownMenuDesktop';
import { DropDownMenuMobile } from './DropDownMenuMobile';

export const DropDownMenu = ({ children, ...rest }: PropsWithChildren) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (!isDesktop) {
    return <DropDownMenuMobile {...rest}>{children}</DropDownMenuMobile>;
  }

  return <DropDownMenuDesktop {...rest}>{children}</DropDownMenuDesktop>;
};
